import React from "react";
import { Input, Option, Select } from "@material-tailwind/react";
import { convertToPresentableText } from "../../../utils/functions";
import { ANNUAL_REVENUES_ENUM, COMPANY_SIZES_ENUM } from "../../../utils/enums";

const CompanyTab = ({ formData, handlers }) => {
  const {
    handleInputChange,
    handleSelectChange,
    handleNestedInputChange
  } = handlers;

  return (
    <div className="space-y-4">
      <div className="border p-4 rounded-md space-y-4">

        <h3 className="text-sm font-medium mb-2">Company Details</h3>

        <div className="flex gap-4 flex-col md:flex-row">
          <Input
            label="Company Name"
            name="companyName"
            value={formData.companyName}
            onChange={handleInputChange}
          />
          <Input
            label="Company Website"
            name="companyWebsite"
            value={formData.companyWebsite}
            onChange={handleInputChange}
          />
        </div>

        <div className="flex gap-4 flex-col md:flex-row">
          <Input
            label="Company or Person LinkedIn Profile (URL or username)"
            name="linkedinProfile"
            value={formData.linkedinProfile}
            onChange={handleInputChange}
          />
        </div>

        <div className="flex gap-4 flex-col md:flex-row">
          <Input
            label="Industry"
            name="industry"
            value={formData.industry}
            onChange={handleInputChange}
          />
          <Input
            label="Company Phone"
            name="companyPhone"
            value={formData.companyPhone}
            onChange={handleInputChange}
          />
        </div>

        <div className="flex gap-4 flex-col md:flex-row">
          <Select
            label="Company Size"
            value={formData.companySize}
            onChange={(value) => handleSelectChange("companySize", value)}
          >
            {COMPANY_SIZES_ENUM.map((size, index) => (
              <Option key={index} value={size}>
                {convertToPresentableText(size)}
              </Option>
            ))}
          </Select>
          <Select
            label="Annual Revenue"
            value={formData.annualRevenue}
            onChange={(value) => handleSelectChange("annualRevenue", value)}
          >
            {ANNUAL_REVENUES_ENUM.map((revenue, index) => (
              <Option key={index} value={revenue}>
                PKR {convertToPresentableText(revenue.split(':')[2])}
              </Option>
            ))}
          </Select>
        </div>
      </div>

      <div className="border p-4 rounded-md">
        <h3 className="text-sm font-medium mb-2">Company Address</h3>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <Input
            label="Street"
            value={formData.companyAddress?.street || ''}
            onChange={(e) => handleNestedInputChange('companyAddress', 'street', e.target.value)}
          />
          <Input
            label="City"
            value={formData.companyAddress?.city || ''}
            onChange={(e) => handleNestedInputChange('companyAddress', 'city', e.target.value)}
          />
          <Input
            label="State/Province"
            value={formData.companyAddress?.state || ''}
            onChange={(e) => handleNestedInputChange('companyAddress', 'state', e.target.value)}
          />
          <Input
            label="Postal/ZIP Code"
            value={formData.companyAddress?.postalCode || ''}
            onChange={(e) => handleNestedInputChange('companyAddress', 'postalCode', e.target.value)}
          />
          <Input
            label="Country"
            value={formData.companyAddress?.country || ''}
            onChange={(e) => handleNestedInputChange('companyAddress', 'country', e.target.value)}
          />
        </div>
      </div>
    </div>
  );
};

export default CompanyTab;